/* Copyright (c) 2018 Scaper */

import * as admin from "firebase-admin";
import { IMinimalAddress, IZip } from "./placeInterface";

type FieldValue = admin.firestore.FieldValue;

export const Collections = {
    ESTIMATES: "estimates",
    PHONE_NUMBER_REQUESTS: "phoneNumberRequests",
    USER_PHONE_NUMBERS: "userPhoneNumbers",
};

export interface IEstimateDocument {
    /** The estimated price, in USD */
    estimatedPrice: number | undefined;

    /** The lot acreage of the place */
    lotAcreage: number | undefined;

    /** The minimal address of the place */
    minimalAddress: IMinimalAddress | undefined;

    /** Google places place id */
    placeId: string;

    /** The time at which this estimate was recorded */
    time: Date | FieldValue;

    /** Firebase authentication user id, undefined if the request was anonymous */
    uid: string | undefined;

    /** The 5 character zip code of the place */
    zip: IZip | undefined;

    /** Zillow property id */
    zpid: string | undefined;
}
